module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pager_buttons"
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.page > 1),
      expression: "page > 1"
    }],
    staticClass: "kp-button kp-button__min btn-blue",
    on: {
      "click": function($event) {
        return _vm.reportPreviousPage()
      }
    }
  }, [_c('i', {
    staticClass: "kp-panel-left",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.list.is_last_page),
      expression: "!list.is_last_page"
    }],
    staticClass: "kp-button kp-button__min btn-blue pull-right",
    on: {
      "click": function($event) {
        return _vm.reportNextPage()
      }
    }
  }, [_c('i', {
    staticClass: "kp-panel-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-67d8d955!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/individual/PaginationButtons.vue
 ** module id = 852
 ** module chunks = 1
 **/